import { useEffect, useState } from "react";
import belgeGrubuVeTuruBasvuruSayilari from "../../services/belgeGrubuVeTuruBasvuruSayilari";
import belgeTuruVeDurumunaGoreBasvuruListesi from "../../services/belgeTuruVeDurumunaGoreBasvuruListesi";
import basvuruDetailLists from "../../services/basvuruDetailLists";
import { Table, Card, Row, Col, Drawer, Modal, Spin, Input, Space, Button, Tooltip as TooltipAnd } from 'antd';
import { UnorderedListOutlined, SearchOutlined, OrderedListOutlined } from '@ant-design/icons'
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts";
import history from "../../history";
import queryString from 'query-string';
import { DATE_FORMAT } from "../../constants";
import moment from "moment";
import ExcelExport from './../ExcelExport';
import { FileExcelOutlined } from "@ant-design/icons";
import basvuruStateZamanlariList from "../../services/basvuruStateZamanlariLists";
import useColumns from "../../hooks/useColumns";
import getParametreDeger from "../../services/getParametreDeger";

const parsed = queryString.parse(history.location.search);

const BelgeGrubuVeTuru = () => {
  const [dates, setDates] = useState([moment(), moment()]);
  const [basvuruSayilari, setBasvuruSayilari] = useState([]);
  const [expandedBasvurus, setExpandedBasvurus] = useState([]);
  const [basvurular, setBasvurular] = useState([]);
  const [filtredBasvurular, setFiltredBasvurular] = useState([]);
  const [basvuruStateList, setBasvuruStateList] = useState([]);
  const [totalCountbasvurular, setTotalCountbasvurular] = useState(0);
  const [visible, setVisible] = useState(false);
  let [basvuruDetails, setBasvuruDetails] = useState([]);
  const [spining, setSpining] = useState(false);
  const [queryDates, setQueryDates] = useState([undefined, undefined]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { basvuruDetailColumns, basvuruColumns, basvuruSurecGecmisColumns } = useColumns();
  const [isCompanyIlOzelIdare, setIsCompanyIlOzelIdare] = useState(false);

  useEffect(() => {
    getParametreDeger('EBELGE.ORTAK.COMPANY_TYPE').then(res => {
      console.log("res.data.result : ", res.data.result);
      debugger;
      setIsCompanyIlOzelIdare(res.data.result == 1);
      debugger;
      console.log("isCompanyIlOzelIdare : ", isCompanyIlOzelIdare);
    });
    belgeGrubuVeTuruBasvuruSayilari(belgeGrubuId)
      .then(res => {
        setBasvuruSayilari(res.data.result);
      });
    setQueryDates(dates);
  }, []);

  const belgeGrubuId = parsed.belgeGrubuId.split(',').map(item => { return parseInt(item) });
  const basvuruDetailColumnsWithIslem = [...basvuruDetailColumns];
  basvuruDetailColumnsWithIslem.push({
    title: 'İşlem',
    key: 'key',
    dataIndex: 'key',
    render: (text, record) => (
      <TooltipAnd title="Süreç Geçmişi Görüntüle">
        <Button type="primary" onClick={() => { openModalBasvuruStateList(record.objectid, record.altSurecTipiId) }} shape="circle" icon={<OrderedListOutlined />} />
      </TooltipAnd>
    ),
  })
  const getBelgeTuruVeDurumunaGoreBasvuruListesi = (belgeGrubuId, belgeTuruId, basvuruAnaDurumId) => {
    setSpining(true);
    belgeTuruVeDurumunaGoreBasvuruListesi(belgeGrubuId, belgeTuruId, basvuruAnaDurumId)
      .then(res => {
        setBasvurular(res.data.result);
        setTotalCountbasvurular(res.data.result.length);
        setSpining(false);
      }).catch(ex => {
        setSpining(false);
      })
  }

  const getBasvuruDetailListesi = (parentObjectId) => {
    setSpining(true);
    basvuruDetailLists(parentObjectId)
      .then(res => {
        setBasvuruDetails(res.data.result);
        setSpining(false);
      }).catch(ex => {
        setSpining(false);
      })

  }

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const expandedRowRender = (record) => {
    return <Card> <Table responsive={true} title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h5 style={{ fontWeight: "bolder" }}>{''}</h5>
      <ExcelExport
        fileName={'Ruhsat Başvuruları ' + " - " + queryDates[0]?.format(DATE_FORMAT) + "-" + queryDates[1]?.format(DATE_FORMAT)}
        downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />} />}
        sheets={[{ data: basvuruDetails, name: 'Test', keyTitles: basvuruDetailKeyTitles }]} />
    </div>} bordered dataSource={basvuruDetails} columns={basvuruDetailColumnsWithIslem} pagination={false} /> </Card>
  };

  const openModalBasvuruStateList = (basvuruId, altSurecTipiId) => {

    let filterModel = {};

    if (basvuruId !== undefined && basvuruId != null) {
      filterModel.basvuruId = basvuruId;
    }
    if (altSurecTipiId !== undefined && altSurecTipiId != null) {
      filterModel.altSurecTipiId = altSurecTipiId;
    }
    setSpining(true);
    basvuruStateZamanlariList(filterModel).then(res => { console.log("Başarılı"); setSpining(false); setBasvuruStateList(res.data.result); showModal(); }).catch(ex => setSpining(false));

  };

  const filterBasvuruColumnsByBelgeGrubuId = () => {
    const filteredBasvuruColumns = filterBasvuruColumnsByCompanyType();
    if (belgeGrubuId === '1') return filteredBasvuruColumns;
    return filteredBasvuruColumns.filter(function check(a) { return (a.key !== 'ruhsatTarih' && a.key !== 'ruhsatSayi' && a.key !== 'insaatAlani') })
  }

  const filterBasvuruColumnsByCompanyType = () => {
    if (isCompanyIlOzelIdare) return basvuruColumns;
    return basvuruColumns.filter(column => column.key != 'ilceAdi');
  }

  const columns = [
    {
      title: 'Belge Türü',
      dataIndex: 'belgeTuruAdi',
      key: 'belgeTuruAdi',
      render: (_, record) => <div className="list-div-cell">
        <span>{record.belgeTuruAdi}</span>
      </div>
    },
    {
      title: 'Aktif Başvuru Sayısı',
      dataIndex: 'aktif',
      key: 'aktif',
      render: (_, record) => <div className="list-div-cell">
        <span>{record.aktif}</span>
        <UnorderedListOutlined onClick={() => {
          setVisible(true);
          getBelgeTuruVeDurumunaGoreBasvuruListesi(belgeGrubuId, record.belgeTuruId, record.aktifId);
        }} />
      </div>
    },
    {
      title: 'Tamamlanan Başvuru Sayısı',
      dataIndex: 'tamamlandi',
      key: 'tamamlandi',
      render: (_, record) => <div className="list-div-cell">
        <span>{record.tamamlandi}</span>
        <UnorderedListOutlined onClick={() => {
          setVisible(true);
          getBelgeTuruVeDurumunaGoreBasvuruListesi(belgeGrubuId, record.belgeTuruId, record.tamamlandiId);
        }} />
      </div>
    },
    {
      title: 'Toplam Başvuru Sayısı',
      render: (_, record) => <div className="list-div-cell">
        <span>{record.tamamlandi + record.aktif}</span>
        <UnorderedListOutlined onClick={() => {
          setVisible(true);
          getBelgeTuruVeDurumunaGoreBasvuruListesi(belgeGrubuId, record.belgeTuruId);
        }} />
      </div>
    }
  ];

  const showModal = () => {
    setIsModalVisible(true);
  };

  let opKeyTitles = basvuruColumns.map(items => { return { key: items.key, title: items.title } });
  const basvuruDetailKeyTitles = basvuruDetailColumnsWithIslem.map(items => { return { key: items.key, title: items.title } });

  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} > <Card
    style={{ margin: "20px" }}
    title={<h2 style={{ fontWeight: "bolder", color: "white" }}>Belge Türlerine Göre Başvuru Sayıları</h2>}
    className="ant-card-head-title-large"
  >
    <Row gutter={16}>
      <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12}>
        <BarChart width={730} height={250} data={basvuruSayilari} >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="belgeTuruAdi" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="aktif" fill="#0000ff" style={{ cursor: "pointer" }} onClick={(record) => {
            setVisible(true);
            getBelgeTuruVeDurumunaGoreBasvuruListesi(belgeGrubuId, record.belgeTuruId, record.aktifId);

          }} />
          <Bar dataKey="tamamlandi" fill="#00ee00" style={{ cursor: "pointer" }} onClick={(record) => {
            setVisible(true);
            getBelgeTuruVeDurumunaGoreBasvuruListesi(belgeGrubuId, record.belgeTuruId, record.tamamlandiId);

          }} />
          <Legend wrapperStyle={{ position: 'relative', marginTop: '5px' }} />
        </BarChart>
      </Col>
      <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12}>
        <Table bordered dataSource={basvuruSayilari} columns={columns}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
            total: basvuruSayilari && basvuruSayilari.length,
            showTotal: (total) => <div>{"Toplam: " + total}</div>
          }}
          summary={pageData => {
            let totalAktif = 0;
            let totalTamamlandi = 0;
            let aktifId = pageData.aktifId;
            let tamamlandiId = pageData.tamamlandiId;
            let belgeTuruId = pageData.belgeTuruId;


            pageData.forEach(({ aktif, tamamlandi, belgeTuruId }) => {
              totalAktif += aktif;
              totalTamamlandi += tamamlandi;
              aktifId = pageData[0].aktifId;
              tamamlandiId = pageData[0].tamamlandiId;
              belgeTuruId = pageData[0].belgeTuruId;
            });

            return (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell style={{ fontWeight: 'bold' }}>Toplam Başvuru Sayısı</Table.Summary.Cell>
                  <Table.Summary.Cell className="list-div-cell">
                    {totalAktif}
                    <UnorderedListOutlined onClick={() => {
                      setVisible(true);
                      getBelgeTuruVeDurumunaGoreBasvuruListesi(belgeGrubuId, belgeTuruId, aktifId);
                    }} />
                  </Table.Summary.Cell>
                  <Table.Summary.Cell className="">
                    <div className="list-div-cell">
                      {totalTamamlandi}
                      <UnorderedListOutlined onClick={() => {
                        setVisible(true);
                        getBelgeTuruVeDurumunaGoreBasvuruListesi(belgeGrubuId, belgeTuruId, tamamlandiId);
                      }} />
                    </div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell className='list-div-cell'>
                    {totalAktif + totalTamamlandi}
                    <UnorderedListOutlined onClick={() => {
                      setVisible(true);
                      getBelgeTuruVeDurumunaGoreBasvuruListesi(belgeGrubuId);
                    }} />
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
        />
      </Col>
    </Row>
    <Row gutter={16}>
      {visible &&
        <Card style={{ marginTop: "8px", width: "100%" }}
          title={<h4 style={{ fontWeight: "bolder", color: "white" }}>Başvuru Bilgileri</h4>}
          className="ant-card-head-title-medium">
          <Table rowKey={"objectid"} bordered dataSource={basvurular} columns={filterBasvuruColumnsByBelgeGrubuId()}
            title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ fontWeight: "bolder" }}>{''}</h3>
              <ExcelExport
                fileName={'Başvuru Bilgileri ' + " - " + queryDates[0]?.format(DATE_FORMAT) + "-" + queryDates[1]?.format(DATE_FORMAT)}
                downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />} />}
                sheets={[{ data: basvurular, name: 'Test', keyTitles: opKeyTitles }]} />
            </div>}
            onChange={
              (pagination, filters, sorter, extra) => {
                if (extra.currentDataSource.length < basvurular.length) {
                  setTotalCountbasvurular(extra.currentDataSource.length);
                }
                else {
                  setFiltredBasvurular(basvurular);
                  setTotalCountbasvurular(basvurular.length);
                }
              }
            }
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
              total: totalCountbasvurular && totalCountbasvurular,
              showTotal: (total) => <div>{"Toplam: " + total}</div>
            }}
            expandable={{
              expandedRowRender: expandedRowRender,
              expandedRowKeys: expandedBasvurus,
              onExpand: (expanded, record) => {

                if (expanded) {
                  //request at geleni state e setle
                  getBasvuruDetailListesi(record.objectid);
                  setExpandedBasvurus([record.objectid]);
                }
                else {
                  setExpandedBasvurus([]);
                }
              }
            }}
          />
          <Modal title="Başvuru Geçmişi" centered visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
            <Table rowKey={"stateId"} bordered dataSource={basvuruStateList} columns={basvuruSurecGecmisColumns}
              pagination={{
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
                total: basvuruStateList && basvuruStateList.length,
                showTotal: (total) => <div>{"Toplam: " + total}</div>
              }}
            />
          </Modal>
        </Card>
      }
    </Row>
    {

    }
  </Card>
  </Spin>
}
export default BelgeGrubuVeTuru;